import React, { Suspense } from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
// import LoaderV1 from '../Components/Common/LoaderV1';

const Index = () => {
    return (
        <React.Fragment>
            {/* <Suspense fallback={<div className="text-center mt-5"><LoaderV1/></div>}> */}
                <Routes>
                    <Route>
                        {publicRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={
                                    <NonAuthLayout>
                                        {route.component}
                                    </NonAuthLayout>
                                }
                                key={idx}
                                exact={true}
                            />
                        ))}
                    </Route>

                    <Route>
                        {authProtectedRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={
                                    <AuthProtected>
                                        <VerticalLayout>{route.component}</VerticalLayout>
                                    </AuthProtected>}
                                key={idx}
                                exact={true}
                            />
                        ))}
                    </Route>
                </Routes>
            {/* </Suspense> */}
        </React.Fragment>
    );
};

export default Index;